import React, { useEffect, useRef, useState } from 'react';
import {
  CardCaptureStepEnum,
  DocumentCaptureStepEnum,
  SellerPage,
  SellerPageTitle,
  cardCaptureType,
  AssetTypesEnum
} from '@types';
import VIN from '@assets/images/vehiclePhoto/vin.png';
import MarineHIN from '@assets/images/vehiclePhoto/HIN.png';
import Plate from '@assets/images/vehiclePhoto/licence_plate.png';
import MarineRegoNumber from '@assets/images/vehiclePhoto/marine_registration_number.png';
import Bank from '@assets/images/bank.png';
import LightIcon from '@assets/icons/LightIcon';
import EyeIcon from '@assets/icons/EyeIcon';
import MobileIcon from '@assets/icons/MobileIcon';
import { Button } from '@material-tailwind/react';
import { useOrgStore, useSellerStore } from '@stores';
import clsx from 'clsx';
import { isDesktop } from 'react-device-detect';
import {
  processFile,
  FILE_VALIDATION_CONFIGS,
  validateFile,
  type ProcessFileMetrics
} from '@utils';
import FileTypeErrorModal from '@components/widgets/FileTypeErrorModal';
import {
  CardCapture,
  CaptureComplete,
  CaptureResult,
  CaptureReview
} from './components';
import VehicleLeft from '@assets/images/vehiclePhoto/car_passenger.png';
import VehicleRight from '@assets/images/vehiclePhoto/car_drivers.png';
import VehicleBack from '@assets/images/vehiclePhoto/car_back.png';
import BikeFront from '@assets/images/vehiclePhoto/bike_front.png';
import BikeBack from '@assets/images/vehiclePhoto/bike_back.png';
import BikeLeft from '@assets/images/vehiclePhoto/bike_left.png';
import BikeRight from '@assets/images/vehiclePhoto/bike_right.png';
import CaravanFront from '@assets/images/vehiclePhoto/caravan_front.png';
import CaravanBack from '@assets/images/vehiclePhoto/caravan_back.png';
import CaravanLeft from '@assets/images/vehiclePhoto/caravan_left.png';
import CaravanRight from '@assets/images/vehiclePhoto/caravan_right.png';
import TrailerFront from '@assets/images/vehiclePhoto/trailer_front.png';
import TrailerBack from '@assets/images/vehiclePhoto/trailer_back.png';
import TrailerLeft from '@assets/images/vehiclePhoto/trailer_left.png';
import TrailerRight from '@assets/images/vehiclePhoto/trailer_right.png';
import BoatFront from '@assets/images/vehiclePhoto/boat-front.png';
import BoatBack from '@assets/images/vehiclePhoto/boat-back.png';
import BoatLeft from '@assets/images/vehiclePhoto/boat-left.png';
import BoatRight from '@assets/images/vehiclePhoto/boat-right.png';

import VehicleFront from '@assets/images/vehiclePhoto/car_front.png';
import VehicleFrontSeats from '@assets/images/vehiclePhoto/car_front_seats.png';
import VehicleBackSeats from '@assets/images/vehiclePhoto/car_back_seats.png';
import VehicleBoot from '@assets/images/vehiclePhoto/car_boot.png';
import CaravanKitchen from '@assets/images/vehiclePhoto/caravan_kitchen.png';
import CaravanLivingArea from '@assets/images/vehiclePhoto/caravan_living.png';
import CaravanSleepingArea from '@assets/images/vehiclePhoto/caravan_sleeping.png';
import OdoMeter from '@assets/images/vehiclePhoto/odometer1.png';
import { getAssetSpecificContent } from '@utils';

type VehicleStartProps = {
  type: cardCaptureType;
  setPage: (page: SellerPage) => void;
  init: () => void;
};

let geolocationResult: any = null;
async function getGeolocationResult() {
  const result = await navigator.permissions.query({
    name: 'geolocation'
  });
  geolocationResult = result;
}
getGeolocationResult();

const VehicleComponent: React.FC<VehicleStartProps> = ({
  type,
  setPage,
  init
}) => {
  const [step, setStep] = useState(0);
  const [primaryColor, setPrimaryColor] = useState('#002861');
  const { organisation } = useOrgStore();
  const [image, setImage] = useState('');
  const [uploadMetrics, setUploadMetrics] = useState<ProcessFileMetrics>();
  const [showFileTypeError, setShowFileTypeError] = useState(false);
  const [fileErrorMessage, setFileErrorMessage] = useState('');
  useEffect(() => {
    if (organisation.primaryColour !== '') {
      setPrimaryColor('#' + organisation.primaryColour);
    }
  }, []);

  // Ensure vehiclePosition is 1 for marine photos
  useEffect(() => {
    // if (type === CardCaptureStepEnum.marinePhoto && vehicle.vehiclePosition !== 1) {
    //   setVehiclePosition({
    //     ...vehicle,
    //     vehiclePosition: 1
    //   });
    // }
  }, [type]);
  const [isUpload, setIsUpload] = useState(false);
  const {
    vinObj,
    numberPlate,
    marineHin,
    marineRegoNumber,
    odometer,
    operatingHours,
    vehicle,
    bank,
    setBankImage,
    setMarineHinImage,
    setMarineRegoNumberImage,
    setActivePageTitle,
    vehicleFront,
    vehicleBack,
    vehicleDriver,
    vehiclePassenger,
    vehicleFrontSeats,
    vehicleBackSeats,
    vehicleBoot,
    vehicleLivingArea,
    vehicleKitchen,
    vehicleSleepingArea,
    marineFront,
    marineBack,
    marineLeft,
    marineRight,
    setVehicleImageLivingArea,
    setVehicleImageKitchen,
    setVehicleImageSleepingArea,
    setVehicleImageFront,
    setVehicleImageFrontSeats,
    setVehicleImageBackSeats,
    setVehicleImageBoot,
    setVehicleImageDriver,
    setVehicleImagePassenger,
    setMarineImageFront,
    setMarineImageBack,
    setMarineImageLeft,
    setMarineImageRight,
    assetType,
    showLocationPrompt,
    setShowLocationPrompt,
    inspectionConfig,
    locationData,
    setVehiclePosition
  } = useSellerStore();
  const [trigger, setTrigger] = useState(false);
  const [trigger2, setTrigger2] = useState(false);
  const handleUpload = async () => {
    if (fileInputRef.current) {
      try {
        // Check if browser supports permission query
        if (
          navigator.permissions ||
          inspectionConfig?.locationSharing === 'SILENT'
        ) {
          const result = geolocationResult;
          // If permission is granted and location data exists, trigger file selection directly
          if (
            result.state === 'granted' ||
            inspectionConfig?.locationSharing === 'SILENT' ||
            (result.state === 'denied' &&
              inspectionConfig?.locationSharing === 'WARNING_PROMPT')
          ) {
            setShowLocationPrompt(false);
            setTimeout(() => fileInputRef.current?.click(), 200);
            return;
          }
        }

        // Fall back to original flow if no permission or API not supported
        setTrigger(true);
        setShowLocationPrompt(true);
      } catch (error) {
        console.error('Error checking location permission:', error);
        // Fall back to original flow if permission check fails
        setTrigger(true);
        setShowLocationPrompt(true);
      }
    }
  };
  useEffect(() => {
    if (trigger && locationData) {
      setShowLocationPrompt(false);
      setTimeout(() => fileInputRef.current?.click(), 300);
      setTrigger(false);
    }
  }, [trigger, locationData]);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Validate file type based on document type
      const validationConfig =
        type === DocumentCaptureStepEnum.bank
          ? FILE_VALIDATION_CONFIGS.BANK_STATEMENT
          : FILE_VALIDATION_CONFIGS.IMAGES_ONLY;

      const validationResult = validateFile(file, validationConfig);

      if (!validationResult.isValid) {
        setFileErrorMessage(
          validationResult.message || 'File validation failed'
        );
        setShowFileTypeError(true);
        // Clear the input
        event.target.value = '';
        return;
      }

      await processFile(file, async (imageDataUrl, compressedFile, metrics) => {
        setImage(imageDataUrl);
        setUploadMetrics(metrics);
        setBankImage({
          ...bank,
          fileName: compressedFile.name
        });
        setIsUpload(true);
        setStep(2);
      });
    } else {
      console.log('No file selected.');
    }
  };
  const fileInputRef = useRef<HTMLInputElement>(null);
  const captureImageBtn = useRef<HTMLInputElement>(null);

  const handleTakePictureForStep1 = async () => {
    if (
      (type === DocumentCaptureStepEnum.bank &&
        !bank.isDone &&
        bank.image === '') ||
      (type === CardCaptureStepEnum.vin &&
        (vinObj.image === '' || vinObj?.file?.fileId)) ||
      (type === CardCaptureStepEnum.marineHin &&
        (marineHin.image === '' || marineHin?.file?.fileId)) ||
      (type === CardCaptureStepEnum.marineRegoNumber &&
        (marineRegoNumber.image === '' || marineRegoNumber?.file?.fileId)) ||
      (type === CardCaptureStepEnum.plateNumber &&
        (numberPlate.image === '' || numberPlate?.file?.fileId)) ||
      (type === CardCaptureStepEnum.odometer &&
        (odometer.image === '' || odometer?.file?.fileId)) ||
      (type === CardCaptureStepEnum.operatingHours &&
        (operatingHours.image === '' || operatingHours?.file?.fileId)) ||
      // Add new asset types
      (type === CardCaptureStepEnum.assetFront &&
        (vehicleFront.image === '' || vehicleFront?.file?.fileId)) ||
      (type === CardCaptureStepEnum.assetLeft &&
        (vehiclePassenger.image === '' || vehiclePassenger?.file?.fileId)) ||
      (type === CardCaptureStepEnum.assetRight &&
        (vehicleDriver.image === '' || vehicleDriver?.file?.fileId)) ||
      (type === CardCaptureStepEnum.assetBack &&
        (vehicleBack.image === '' || vehicleBack?.file?.fileId)) ||
      // Add marine photo types
      (type === CardCaptureStepEnum.marineFront &&
        (marineFront.image === '' || marineFront?.file?.fileId)) ||
      (type === CardCaptureStepEnum.marineBack &&
        (marineBack.image === '' || marineBack?.file?.fileId)) ||
      (type === CardCaptureStepEnum.marineLeft &&
        (marineLeft.image === '' || marineLeft?.file?.fileId)) ||
      (type === CardCaptureStepEnum.marineRight &&
        (marineRight.image === '' || marineRight?.file?.fileId)) ||
      (type === CardCaptureStepEnum.internalFront &&
        (vehicleFrontSeats.image === '' || vehicleFrontSeats?.file?.fileId)) ||
      (type === CardCaptureStepEnum.internalBack &&
        (vehicleBackSeats.image === '' || vehicleBackSeats?.file?.fileId)) ||
      (type === CardCaptureStepEnum.internalBoot &&
        (vehicleBoot.image === '' || vehicleBoot?.file?.fileId)) ||
      (type === CardCaptureStepEnum.internalLivingArea &&
        (vehicleLivingArea.image === '' || vehicleLivingArea?.file?.fileId)) ||
      (type === CardCaptureStepEnum.internalKitchen &&
        (vehicleKitchen.image === '' || vehicleKitchen?.file?.fileId)) ||
      (type === CardCaptureStepEnum.internalSleepingArea &&
        (vehicleSleepingArea.image === '' || vehicleSleepingArea?.file?.fileId))
    ) {
      if (captureImageBtn.current) {
        try {
          // Check if browser supports permission query
          if (
            navigator.permissions ||
            inspectionConfig?.locationSharing === 'SILENT'
          ) {
            const result = geolocationResult;
            if (
              result.state === 'granted' ||
              inspectionConfig?.locationSharing === 'SILENT' ||
              (result.state === 'denied' &&
                inspectionConfig?.locationSharing === 'WARNING_PROMPT')
            ) {
              setShowLocationPrompt(false);
              setTimeout(() => captureImageBtn.current?.click(), 300);
              return;
            }
          }
          setTrigger2(true);
          setShowLocationPrompt(true);
        } catch (error) {
          console.error('Error checking location permission:', error);
          setTrigger2(true);
          setShowLocationPrompt(true);
        }
      }
    } else if ((type === CardCaptureStepEnum.vehiclePhoto || type === CardCaptureStepEnum.marinePhoto) && !vehicle.isDone) {
      if (captureImageBtn.current) {
        try {
          // Check if browser supports permission query
          if (
            navigator.permissions ||
            inspectionConfig?.locationSharing === 'SILENT'
          ) {
            const result = geolocationResult;
            if (
              result.state === 'granted' ||
              inspectionConfig?.locationSharing === 'SILENT' ||
              (result.state === 'denied' &&
                inspectionConfig?.locationSharing === 'WARNING_PROMPT')
            ) {
              setShowLocationPrompt(false);
              setTimeout(() => captureImageBtn.current?.click(), 300);
              return;
            }
          }
          setTrigger2(true);
          setShowLocationPrompt(true);
        } catch (error) {
          console.error('Error checking location permission:', error);
          setTrigger2(true);
          setShowLocationPrompt(true);
        }
      }
    } else if (
      (type === DocumentCaptureStepEnum.bank &&
        (bank.image !== '' || bank?.file?.fileId)) ||
      ((type === CardCaptureStepEnum.vehiclePhoto || type === CardCaptureStepEnum.marinePhoto) && vehicle.isDone)
    ) {
      setStep(2);
    } else {
      setStep(1);
    }
  };

  useEffect(() => {
    if (trigger2 && locationData) {
      setShowLocationPrompt(false);
      setTimeout(() => captureImageBtn.current?.click(), 300);
      setTrigger2(false);
    }
  }, [trigger2, locationData]);

  const handleCapture = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Validate file type based on document type
      const validationConfig =
        type === DocumentCaptureStepEnum.bank
          ? FILE_VALIDATION_CONFIGS.BANK_STATEMENT
          : FILE_VALIDATION_CONFIGS.IMAGES_ONLY;

      const validationResult = validateFile(file, validationConfig);

      if (!validationResult.isValid) {
        setFileErrorMessage(
          validationResult.message || 'File validation failed'
        );
        setShowFileTypeError(true);
        // Clear the input
        event.target.value = '';
        return;
      }

      await processFile(file, async (imageDataUrl, compressedFile, metrics) => {
        setImage(imageDataUrl);
        setUploadMetrics(metrics);
        if (type === DocumentCaptureStepEnum.bank) {
          setBankImage({ ...bank });
        } else if (type === CardCaptureStepEnum.marineHin) {
          setMarineHinImage({ ...marineHin });
        } else if (type === CardCaptureStepEnum.marineRegoNumber) {
          setMarineRegoNumberImage({ ...marineRegoNumber });
        } else if (type === CardCaptureStepEnum.assetFront) {
          setVehicleImageFront({ ...vehicleFront });
        } else if (type === CardCaptureStepEnum.assetLeft) {
          setVehicleImagePassenger({ ...vehiclePassenger });
        } else if (type === CardCaptureStepEnum.assetRight) {
          setVehicleImageDriver({ ...vehicleDriver });
        } else if (type === CardCaptureStepEnum.assetBack) {
          setVehicleImageBoot({ ...vehicleBack });
        } else if (type === CardCaptureStepEnum.internalFront) {
          setVehicleImageFrontSeats({ ...vehicleFrontSeats });
        } else if (type === CardCaptureStepEnum.internalBack) {
          setVehicleImageBackSeats({ ...vehicleBackSeats });
        } else if (type === CardCaptureStepEnum.internalBoot) {
          setVehicleImageBoot({ ...vehicleBoot });
        } else if (type === CardCaptureStepEnum.internalLivingArea) {
          setVehicleImageLivingArea({ ...vehicleLivingArea });
        } else if (type === CardCaptureStepEnum.internalKitchen) {
          setVehicleImageKitchen({ ...vehicleKitchen });
        } else if (type === CardCaptureStepEnum.internalSleepingArea) {
          setVehicleImageSleepingArea({ ...vehicleSleepingArea });
        } else if (type === CardCaptureStepEnum.marineFront) {
          setMarineImageFront({ ...marineFront });
        } else if (type === CardCaptureStepEnum.marineBack) {
          setMarineImageBack({ ...marineBack });
        } else if (type === CardCaptureStepEnum.marineLeft) {
          setMarineImageLeft({ ...marineLeft });
        } else if (type === CardCaptureStepEnum.marineRight) {
          setMarineImageRight({ ...marineRight });
        }
        setStep(2);
        event.stopPropagation();
      });
    } else {
      console.log('No file selected.');
    }
  };
  useEffect(() => {
    scrollTo(0, 0);
    let title: any = SellerPageTitle.Blank;
    if (type === CardCaptureStepEnum.vin) {
      title =
        step === 0
          ? SellerPageTitle.VIN
          : step === 2
            ? SellerPageTitle.VinDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.plateNumber) {
      title =
        step === 0
          ? SellerPageTitle.Plate
          : step === 2
            ? SellerPageTitle.PlateDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.marineHin) {
      title =
        step === 0
          ? 'Watercraft HIN'
          : step === 2
            ? 'Watercraft HIN Details'
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.marineRegoNumber) {
      title =
        step === 0
          ? 'Watercraft Registration Number'
          : step === 2
            ? 'Watercraft Registration Number Details'
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.odometer) {
      title =
        step === 0
          ? SellerPageTitle.Odometer
          : step === 2
            ? SellerPageTitle.OdometerDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.operatingHours) {
      title =
        step === 0
          ? SellerPageTitle.OperatingHours
          : step === 2
            ? SellerPageTitle.OperatingHours
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (DocumentCaptureStepEnum.bank === type) {
      title =
        step === 0
          ? SellerPageTitle.bank
          : step === 2
            ? SellerPageTitle.bankDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === DocumentCaptureStepEnum.payoutLetter) {
      title =
        step === 0
          ? SellerPageTitle.payoutLetter
          : step === 2
            ? SellerPageTitle.payoutLetterDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.vehiclePhoto) {
      title =
        step === 0
          ? getAssetSpecificContent(assetType as AssetTypesEnum).title +
            ' ' +
            SellerPageTitle.VehiclePhotos
          : step === 2
            ? vehicle.vehiclePosition === 1
              ? getAssetSpecificContent(assetType as AssetTypesEnum).sides.front
              : vehicle.vehiclePosition === 2
                ? getAssetSpecificContent(assetType as AssetTypesEnum).sides
                    .driver
                : vehicle.vehiclePosition === 3
                  ? getAssetSpecificContent(assetType as AssetTypesEnum).sides
                      .passenger
                  : getAssetSpecificContent(assetType as AssetTypesEnum).sides
                      .back
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.marinePhoto) {
      title =
        step === 0
          ? 'Watercraft Photos'
          : step === 2
            ? vehicle.vehiclePosition === 1
              ? 'Watercraft Front'
              : vehicle.vehiclePosition === 2
                ? 'Watercraft Starboard Side'
                : vehicle.vehiclePosition === 3
                  ? 'Watercraft Port Side'
                  : 'Watercraft Back'
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.assetFront) {
      title =
        step === 0
          ? getAssetSpecificContent(assetType as AssetTypesEnum).sides.front
          : step === 2
            ? getAssetSpecificContent(assetType as AssetTypesEnum).sides.front
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.assetLeft) {
      title =
        step === 0
          ? getAssetSpecificContent(assetType as AssetTypesEnum).sides.passenger
          : step === 2
            ? getAssetSpecificContent(assetType as AssetTypesEnum).sides
                .passenger
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.assetRight) {
      title =
        step === 0
          ? getAssetSpecificContent(assetType as AssetTypesEnum).sides.driver
          : step === 2
            ? getAssetSpecificContent(assetType as AssetTypesEnum).sides.driver
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.assetBack) {
      title =
        step === 0
          ? getAssetSpecificContent(assetType as AssetTypesEnum).sides.back
          : step === 2
            ? getAssetSpecificContent(assetType as AssetTypesEnum).sides.back
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.internalFront) {
      title =
        step === 0
          ? SellerPageTitle.VehicleFrontSeats
          : step === 2
            ? SellerPageTitle.VehicleFrontSeats
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.internalBack) {
      title =
        step === 0
          ? SellerPageTitle.VehicleBackSeats
          : step === 2
            ? SellerPageTitle.VehicleBackSeats
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.internalBoot) {
      title =
        step === 0
          ? SellerPageTitle.VehicleBoot
          : step === 2
            ? SellerPageTitle.VehicleBootDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.internalLivingArea) {
      title =
        step === 0
          ? SellerPageTitle.VehicleLivingArea
          : step === 2
            ? SellerPageTitle.VehicleLivingAreaDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.internalKitchen) {
      title =
        step === 0
          ? SellerPageTitle.VehicleKitchen
          : step === 2
            ? SellerPageTitle.VehicleKitchenDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.internalSleepingArea) {
      title =
        step === 0
          ? SellerPageTitle.VehicleSleepingArea
          : step === 2
            ? SellerPageTitle.VehicleSleepingAreaDetails
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.marineFront) {
      title =
        step === 0
          ? 'Watercraft Front'
          : step === 2
            ? 'Watercraft Front'
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.marineBack) {
      title =
        step === 0
          ? 'Watercraft Back'
          : step === 2
            ? 'Watercraft Back'
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.marineLeft) {
      title =
        step === 0
          ? 'Watercraft Port Side'
          : step === 2
            ? 'Watercraft Port Side'
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    } else if (type === CardCaptureStepEnum.marineRight) {
      title =
        step === 0
          ? 'Watercraft Starboard Side'
          : step === 2
            ? 'Watercraft Starboard Side'
            : step === 3
              ? SellerPageTitle.Review
              : SellerPageTitle.Blank;
    }
    setActivePageTitle(title);
  }, [type, step, vehicle.vehiclePosition]);

  const captureButtonTestId = (action: 'continue' | 'upload') =>
    `seller-capture-${type.toLowerCase()}-${action}-button`;

  if (step === 1) {
    return (
      <CardCapture
        primaryColor={primaryColor}
        setLoadImage={(capturedImage: string) => {
          setUploadMetrics(undefined);
          setImage(capturedImage);
        }}
        type={type}
        vehiclePosition={vehicle.vehiclePosition}
        setStep={setStep}
      />
    );
  } else if (step === 2) {
    return (
      <CaptureResult
        type={type}
        isUpload={isUpload}
        primaryColor={primaryColor}
        image={image}
        uploadMetrics={uploadMetrics}
        setLoadImage={setImage}
        setStep={setStep}
      />
    );
  } else if (step === 3) {
    return (
      <CaptureReview
        type={type}
        primaryColor={primaryColor}
        setStep={setStep}
      />
    );
  } else if (step === 4) {
    return (
      <CaptureComplete
        type={type}
        primaryColor={primaryColor}
        setStep={setStep}
        vehiclePosition={vehicle.vehiclePosition}
        setPage={setPage}
        setLoadImage={setImage}
        setUploadMetrics={setUploadMetrics}
        init={init}
      />
    );
  }
  return (
    <div className="flex flex-col tablet-portrait:w-[361px] tablet-portrait:mx-auto">
      <div
        className={
          (clsx('flex flex-col gap-10'),
          type === DocumentCaptureStepEnum.bank ? 'pb-[120px]' : 'pb-16')
        }>
        <div className="grow flex flex-col justify-center items-center">
          {type === CardCaptureStepEnum.vin && <img className="" src={VIN} />}
          {type === CardCaptureStepEnum.plateNumber && (
            <img className="" src={Plate} />
          )}
          {type === CardCaptureStepEnum.marineHin && (
            <img className="" src={MarineHIN} />
          )}
          {type === CardCaptureStepEnum.marineRegoNumber && (
            <img className="" src={MarineRegoNumber} />
          )}
          {type === CardCaptureStepEnum.odometer && (
            <img className="" src={OdoMeter} />
          )}
          {type === DocumentCaptureStepEnum.bank && (
            <img className="" src={Bank} />
          )}
          {type === CardCaptureStepEnum.vehiclePhoto &&
            vehicle.vehiclePosition === 1 &&
            assetType === AssetTypesEnum.CAR && (
              <img className="" src={VehicleFront} />
            )}

          {type === CardCaptureStepEnum.vehiclePhoto &&
            vehicle.vehiclePosition === 1 &&
            assetType === AssetTypesEnum.MOTOR_CYCLE && (
              <img className="" src={BikeFront} />
            )}
          {type === CardCaptureStepEnum.vehiclePhoto &&
            vehicle.vehiclePosition === 1 &&
            assetType === AssetTypesEnum.TRAILER && (
              <img className="" src={TrailerFront} />
            )}
          {type === CardCaptureStepEnum.vehiclePhoto &&
            vehicle.vehiclePosition === 1 &&
            assetType === AssetTypesEnum.CAMPERVAN && (
              <img className="" src={CaravanFront} />
            )}
          {type === CardCaptureStepEnum.vehiclePhoto &&
            vehicle.vehiclePosition === 1 &&
            assetType === AssetTypesEnum.MARINE && (
              <img className="" src={BoatFront} />
            )}
          {/* Marine Photo type - 4 step flow */}
          {type === CardCaptureStepEnum.marinePhoto &&
            vehicle.vehiclePosition === 1 && (
              <img className="" src={BoatFront} />
            )}
          {type === CardCaptureStepEnum.marinePhoto &&
            vehicle.vehiclePosition === 2 && (
              <img className="" src={BoatRight} />
            )}
          {type === CardCaptureStepEnum.marinePhoto &&
            vehicle.vehiclePosition === 3 && (
              <img className="" src={BoatLeft} />
            )}
          {type === CardCaptureStepEnum.marinePhoto &&
            vehicle.vehiclePosition === 4 && (
              <img className="" src={BoatBack} />
            )}
          {type === CardCaptureStepEnum.assetFront &&
            assetType === AssetTypesEnum.CAR && (
              <img className="" src={VehicleFront} />
            )}

          {type === CardCaptureStepEnum.assetLeft &&
            assetType === AssetTypesEnum.CAR && (
              <img className="" src={VehicleLeft} />
            )}
          {type === CardCaptureStepEnum.assetRight &&
            assetType === AssetTypesEnum.CAR && (
              <img className="" src={VehicleRight} />
            )}
          {type === CardCaptureStepEnum.assetBack &&
            assetType === AssetTypesEnum.CAR && (
              <img className="" src={VehicleBack} />
            )}
          {type === CardCaptureStepEnum.assetFront &&
            assetType === AssetTypesEnum.MOTOR_CYCLE && (
              <img className="" src={BikeFront} />
            )}
          {type === CardCaptureStepEnum.assetFront &&
            assetType === AssetTypesEnum.MARINE && (
              <img className="" src={BoatFront} />
            )}
          {type === CardCaptureStepEnum.assetBack &&
            assetType === AssetTypesEnum.MOTOR_CYCLE && (
              <img className="" src={BikeBack} />
            )}
          {type === CardCaptureStepEnum.assetBack &&
            assetType === AssetTypesEnum.MARINE && (
              <img className="" src={BoatBack} />
            )}
          {type === CardCaptureStepEnum.assetLeft &&
            assetType === AssetTypesEnum.MOTOR_CYCLE && (
              <img className="" src={BikeLeft} />
            )}
          {type === CardCaptureStepEnum.assetLeft &&
            assetType === AssetTypesEnum.MARINE && (
              <img className="" src={BoatLeft} />
            )}
          {type === CardCaptureStepEnum.assetRight &&
            assetType === AssetTypesEnum.MOTOR_CYCLE && (
              <img className="" src={BikeRight} />
            )}
          {type === CardCaptureStepEnum.assetRight &&
            assetType === AssetTypesEnum.MARINE && (
              <img className="" src={BoatRight} />
            )}
          {type === CardCaptureStepEnum.assetFront &&
            assetType === AssetTypesEnum.CAMPERVAN && (
              <img className="" src={CaravanFront} />
            )}
          {type === CardCaptureStepEnum.assetBack &&
            assetType === AssetTypesEnum.CAMPERVAN && (
              <img className="" src={CaravanBack} />
            )}
          {type === CardCaptureStepEnum.assetLeft &&
            assetType === AssetTypesEnum.CAMPERVAN && (
              <img className="" src={CaravanLeft} />
            )}
          {type === CardCaptureStepEnum.assetRight &&
            assetType === AssetTypesEnum.CAMPERVAN && (
              <img className="" src={CaravanRight} />
            )}
          {type === CardCaptureStepEnum.assetLeft &&
            assetType === AssetTypesEnum.TRAILER && (
              <img className="" src={TrailerLeft} />
            )}
          {type === CardCaptureStepEnum.assetRight &&
            assetType === AssetTypesEnum.TRAILER && (
              <img className="" src={TrailerRight} />
            )}
          {type === CardCaptureStepEnum.assetBack &&
            assetType === AssetTypesEnum.TRAILER && (
              <img className="" src={TrailerBack} />
            )}
          {type === CardCaptureStepEnum.assetFront &&
            assetType === AssetTypesEnum.TRAILER && (
              <img className="" src={TrailerFront} />
            )}
          {/* Marine photo types */}
          {type === CardCaptureStepEnum.marineFront && (
            <img className="" src={BoatFront} />
          )}
          {type === CardCaptureStepEnum.marineBack && (
            <img className="" src={BoatBack} />
          )}
          {type === CardCaptureStepEnum.marineLeft && (
            <img className="" src={BoatLeft} />
          )}
          {type === CardCaptureStepEnum.marineRight && (
            <img className="" src={BoatRight} />
          )}
          {type === CardCaptureStepEnum.internalFront && (
            <img className="" src={VehicleFrontSeats} />
          )}
          {type === CardCaptureStepEnum.internalBack && (
            <img className="" src={VehicleBackSeats} />
          )}
          {type === CardCaptureStepEnum.internalBoot && (
            <img className="" src={VehicleBoot} />
          )}
          {type === CardCaptureStepEnum.internalLivingArea && (
            <img className="" src={CaravanLivingArea} />
          )}
          {type === CardCaptureStepEnum.internalKitchen && (
            <img className="" src={CaravanKitchen} />
          )}
          {type === CardCaptureStepEnum.internalSleepingArea && (
            <img className="" src={CaravanSleepingArea} />
          )}
          {/* {type === CardCaptureStepEnum.internalSleepingArea && (
            <img className="" src={VehicleSleepingArea} />
          )} */}
          <p className="text-grey-800 text-lg text-center font-semibold mt-8">
            {type === CardCaptureStepEnum.vin && 'Take a photo of the VIN'}
            {type === CardCaptureStepEnum.marineHin &&
              'Take a photo of the Hull Identification Number (HIN)'}
            {type === CardCaptureStepEnum.marineRegoNumber &&
              'Take a photo of the Watercraft Registration Number'}
            {!isDesktop &&
              type === DocumentCaptureStepEnum.bank &&
              'Take a photo of your bank statement header including account number & BSB'}
            {isDesktop &&
              type === DocumentCaptureStepEnum.bank &&
              'Upload a copy of your bank statement header including account number & BSB'}
            {type === CardCaptureStepEnum.plateNumber &&
              'Take a photo of the number plate'}
            {type === CardCaptureStepEnum.odometer &&
              'Take a photo of the odometer'}
            {type === CardCaptureStepEnum.operatingHours &&
              'Take a photo of the Operating Hours'}
            {type === CardCaptureStepEnum.vehiclePhoto &&
              (vehicle.vehiclePosition === 1
                ? 'Start with the front'
                : vehicle.vehiclePosition === 2
                  ? 'Start with the ' +
                    getAssetSpecificContent(
                      assetType as AssetTypesEnum
                    ).sides.driver.toLowerCase()
                  : vehicle.vehiclePosition === 3
                    ? 'Start with the ' +
                      getAssetSpecificContent(
                        assetType as AssetTypesEnum
                      ).sides.passenger.toLowerCase()
                    : 'Start with the side')}
            {type === CardCaptureStepEnum.marinePhoto &&
              (vehicle.vehiclePosition === 1
                ? 'Start with the watercraft front'
                : vehicle.vehiclePosition === 2
                  ? 'Start with the watercraft starboard side'
                  : vehicle.vehiclePosition === 3
                    ? 'Start with the watercraft port side'
                    : 'Start with the watercraft back')}
            {type === CardCaptureStepEnum.assetFront &&
              'Take a photo of the front'}
            {type === CardCaptureStepEnum.assetLeft &&
              'Take a photo of the ' +
                getAssetSpecificContent(
                  assetType as AssetTypesEnum
                ).sides.passenger.toLowerCase()}
            {type === CardCaptureStepEnum.assetRight &&
              'Take a photo of the ' +
                getAssetSpecificContent(
                  assetType as AssetTypesEnum
                ).sides.driver.toLowerCase()}
            {type === CardCaptureStepEnum.assetBack &&
              'Take a photo of the back'}
            {type === CardCaptureStepEnum.internalFront &&
              'Take a photo of the front seats'}
            {type === CardCaptureStepEnum.internalBack &&
              'Take a photo of the back seats'}
            {type === CardCaptureStepEnum.internalBoot &&
              'Take a photo of the boot'}
            {type === CardCaptureStepEnum.internalLivingArea &&
              'Take a photo of the living area'}
            {type === CardCaptureStepEnum.internalKitchen &&
              'Take a photo of the kitchen'}
            {type === CardCaptureStepEnum.internalSleepingArea &&
              'Take a photo of the sleeping area'}
            {type === CardCaptureStepEnum.marineFront &&
              'Take a photo of the watercraft front'}
            {type === CardCaptureStepEnum.marineBack &&
              'Take a photo of the watercraft back'}
            {type === CardCaptureStepEnum.marineLeft &&
              'Take a photo of the watercraft port side'}
            {type === CardCaptureStepEnum.marineRight &&
              'Take a photo of the watercraft starboard side'}
          </p>
          {(type === DocumentCaptureStepEnum.bank ||
            type === CardCaptureStepEnum.vin ||
            type === CardCaptureStepEnum.marineHin ||
            type === CardCaptureStepEnum.marineRegoNumber ||
            type === CardCaptureStepEnum.plateNumber ||
            type === CardCaptureStepEnum.odometer ||
            type === CardCaptureStepEnum.operatingHours ||
            type === CardCaptureStepEnum.vehiclePhoto ||
            type === CardCaptureStepEnum.marinePhoto ||
            type === CardCaptureStepEnum.assetFront ||
            type === CardCaptureStepEnum.assetLeft ||
            type === CardCaptureStepEnum.assetRight ||
            type === CardCaptureStepEnum.assetBack ||
            type === CardCaptureStepEnum.internalFront ||
            type === CardCaptureStepEnum.internalBack ||
            type === CardCaptureStepEnum.internalBoot ||
            type === CardCaptureStepEnum.internalLivingArea ||
            type === CardCaptureStepEnum.internalKitchen ||
            type === CardCaptureStepEnum.internalSleepingArea ||
            type === CardCaptureStepEnum.marineFront ||
            type === CardCaptureStepEnum.marineBack ||
            type === CardCaptureStepEnum.marineLeft ||
            type === CardCaptureStepEnum.marineRight) && (
            <>
              <input
                ref={captureImageBtn}
                type="file"
                capture="environment"
                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                style={{ display: 'none' }}
                onChange={async (event: React.ChangeEvent<HTMLInputElement>) => await handleCapture(event)}
              />
              <input
                type="file"
                ref={fileInputRef}
                accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf,.pdf,.PDF"
                onChange={async (event: React.ChangeEvent<HTMLInputElement>) => await handleFileChange(event)}
                style={{ display: 'none' }}
              />
            </>
          )}
        </div>

        <div className="">
          {type === CardCaptureStepEnum.vin && (
            <div className="text-sm flex flex-col gap-1">
              <p className="text-gray-600">
                A Vehicle Identification Number (VIN) can typically be found on
                the following:
              </p>
              {assetType === AssetTypesEnum.CAR && (
                <ol className="list-disc pl-4 text-gray-600 text-sm">
                  <li>
                    stamped on the dashboard near the windscreen (on the
                    driver&apos;s side of the vehicle)
                  </li>
                  <li>
                    on a plate sticker on the driver&apos;s side door jamb
                  </li>
                  <li>stamped on the engine firewall</li>
                </ol>
              )}
              {assetType === AssetTypesEnum.CAMPERVAN && (
                <ol className="list-disc pl-4 text-gray-600 text-sm">
                  <li>
                    <span className="font-bold">Drawbar or A-frame</span> – Look
                    for a stamped number on the metal frame near the hitch.
                  </li>
                  <li>
                    <span className="font-bold">Near the front door</span> –
                    Some caravans have a compliance plate or sticker inside the
                    doorway or on the door frame.
                  </li>
                  <li>
                    <span className="font-bold">Chassis rails</span> – The VIN
                    may be stamped into the steel chassis, often on the
                    right-hand chassis, often on the right-hand side.
                  </li>
                </ol>
              )}
              {assetType === AssetTypesEnum.MOTOR_CYCLE && (
                <ol className="list-disc pl-4 text-gray-600 text-sm">
                  <li>
                    <span className="font-bold">
                      Headstock or steering neck
                    </span>{' '}
                    – Look for a stamped number on the metal frame just below
                    the handlebars, near the steering column.
                  </li>
                  <li>
                    <span className="font-bold">Compliance plate</span> –
                    Usually riveted to the frame or near the headstock; this
                    plate lists the VIN and other details.
                  </li>
                  <li>
                    <span className="font-bold">Frame near the engine</span> –
                    Some bikes have the VIN stamped on the main frame rails or
                    near the engine casing.
                  </li>
                </ol>
              )}
              {assetType === AssetTypesEnum.TRAILER && (
                <ol className="list-disc pl-4 text-gray-600 text-sm">
                  <li>
                    <span className="font-bold">Drawbar or A-frame</span> –
                    Check for a stamped VIN on the metal frame near the
                    coupling/hitch.
                  </li>
                  <li>
                    <span className="font-bold">Compliance plate</span> –
                    Usually riveted to the drawbar or inside a metal toolbox;
                    this plate includes the VIN and other manufacturing details.
                  </li>
                  <li>
                    <span className="font-bold">Chassis rail</span> – Some
                    trailers have the VIN stamped into the steel chassis, often
                    on the right-hand side.
                  </li>
                </ol>
              )}
              {assetType === AssetTypesEnum.EQUIPMENT && (
                <ol className="list-disc pl-4 text-gray-600 text-sm">
                  <li>
                    <span className="font-bold">Main chassis or frame</span> –
                    Look for a stamped VIN on the main structural frame, often
                    near the front or under the cabin.
                  </li>
                  <li>
                    <span className="font-bold">
                      Cab area or operator&apos;s console
                    </span>{' '}
                    – Some machines display the VIN inside the cab, often on a
                    plate or sticker near the controls.
                  </li>
                  <li>
                    <span className="font-bold">
                      Near the engine or transmission
                    </span>{' '}
                    – Check the area around the engine bay or gearbox housing,
                    depending on the equipment type.
                  </li>
                </ol>
              )}
            </div>
          )}
          {type === CardCaptureStepEnum.plateNumber && (
            <p className="text-gray-600 text-sm">
              A vehicle&apos;s number plate may also be referred to as a
              registration plate or licence plate, and can be found on the front
              and back of registered vehicles.
            </p>
          )}
          {type === CardCaptureStepEnum.odometer && (
            <div className="flex flex-col gap-4">
              <p className="text-gray-600 text-sm">
                To read your odometer on a car with a digital helper screen,
                scroll through the different display faces until you find{' '}
                <span className="font-bold">ODO</span>.
              </p>
              <p className="text-gray-600 text-sm">
                Mechanical odometers are usually placed near the information
                circle on the speedometer.
              </p>
            </div>
          )}
          {type === CardCaptureStepEnum.operatingHours && (
            <div className="flex flex-col gap-4 mt-12">
              <p className="text-[#101828] text-sm">
                Provide a record of the operating hours on this asset to verify
                its usage and condition.
              </p>
              <p className="text-[#101828] text-sm">
                The operating hours are typically displayed on the
                machine&apos;s hour meter or digital dashboard. Depending on the
                equipment type, you may find this:
              </p>
              <ul className="list-disc pl-4 text-[#101828] text-sm">
                <li>
                  On the <span className="font-bold">main dashboard</span> near
                  the ignition or control panel.
                </li>
                <li>
                  On a <span className="font-bold">digital screen</span> within
                  the machine&apos;s settings menu.
                </li>
                <li>
                  On an <span className="font-bold">analog hour meter</span>,
                  usually located in the cab, under the seat, or near the
                  engine.
                </li>
              </ul>
              <p className="text-[#101828] text-sm">
                If you are unsure, check the equipment&apos;s user manual or
                look for a label that says &quot;
                <span className="font-bold">Hours</span>,&quot; &quot;
                <span className="font-bold">Service Hours</span>,&quot; or
                &quot;<span className="font-bold">Engine Hours</span>.&quot;
              </p>
            </div>
          )}
          {type === DocumentCaptureStepEnum.bank && (
            <p className="text-gray-600 text-sm">
              We ask for your bank details to ensure that any funds or payments
              related to the transaction are correctly processed and sent to
              you.
            </p>
          )}
          {type === CardCaptureStepEnum.vehiclePhoto && (
            <>
              {vehicle.vehiclePosition === 1 && (
                <p className="text-gray-600 text-sm">
                  Ensure the photo is taken directly in front of the{' '}
                  {
                    getAssetSpecificContent(assetType as AssetTypesEnum)
                      .lowerTitle
                  }{' '}
                  with no obstructions.
                </p>
              )}
              {vehicle.vehiclePosition === 2 && (
                <p className="text-gray-600 text-sm">
                  Ensure the photo is taken from the{' '}
                  {getAssetSpecificContent(
                    assetType as AssetTypesEnum
                  ).sides.driver.toLocaleLowerCase()}{' '}
                  of the{' '}
                  {
                    getAssetSpecificContent(assetType as AssetTypesEnum)
                      .lowerTitle
                  }{' '}
                  with no obstructions.
                </p>
              )}
              {vehicle.vehiclePosition === 3 && (
                <p className="text-gray-600 text-sm">
                  Ensure the photo is taken from the{' '}
                  {getAssetSpecificContent(
                    assetType as AssetTypesEnum
                  ).sides.passenger.toLocaleLowerCase()}{' '}
                  of the{' '}
                  {
                    getAssetSpecificContent(assetType as AssetTypesEnum)
                      .lowerTitle
                  }{' '}
                  with no obstructions.
                </p>
              )}
              {vehicle.vehiclePosition === 4 && (
                <p className="text-gray-600 text-sm">
                  Ensure the photo is taken from the back of the{' '}
                  {
                    getAssetSpecificContent(assetType as AssetTypesEnum)
                      .lowerTitle
                  }{' '}
                  with no obstructions.
                </p>
              )}
            </>
          )}
          {type === CardCaptureStepEnum.marinePhoto && (
            <>
              {vehicle.vehiclePosition === 1 && (
                <p className="text-gray-600 text-sm">
                  Ensure the photo is taken directly in front of the watercraft
                  with no obstructions.
                </p>
              )}
              {vehicle.vehiclePosition === 2 && (
                <p className="text-gray-600 text-sm">
                  Ensure the photo is taken from the starboard side of the
                  watercraft with no obstructions.
                </p>
              )}
              {vehicle.vehiclePosition === 3 && (
                <p className="text-gray-600 text-sm">
                  Ensure the photo is taken from the port side of the watercraft
                  with no obstructions.
                </p>
              )}
              {vehicle.vehiclePosition === 4 && (
                <p className="text-gray-600 text-sm">
                  Ensure the photo is taken from the back of the watercraft with
                  no obstructions.
                </p>
              )}
            </>
          )}
          {type === CardCaptureStepEnum.assetFront && (
            <p className="text-gray-600 text-sm">
              Ensure the photo is taken directly in front of the{' '}
              {getAssetSpecificContent(assetType as AssetTypesEnum).lowerTitle}{' '}
              with no obstructions.
            </p>
          )}
          {type === CardCaptureStepEnum.assetLeft && (
            <p className="text-gray-600 text-sm">
              Ensure the photo is taken from the{' '}
              {getAssetSpecificContent(
                assetType as AssetTypesEnum
              ).sides.passenger.toLocaleLowerCase()}{' '}
              of the{' '}
              {getAssetSpecificContent(assetType as AssetTypesEnum).lowerTitle}{' '}
              with no obstructions.
            </p>
          )}
          {type === CardCaptureStepEnum.assetRight && (
            <p className="text-gray-600 text-sm">
              Ensure the photo is taken from the{' '}
              {getAssetSpecificContent(
                assetType as AssetTypesEnum
              ).sides.driver.toLocaleLowerCase()}{' '}
              of the{' '}
              {getAssetSpecificContent(assetType as AssetTypesEnum).lowerTitle}{' '}
              with no obstructions.
            </p>
          )}
          {type === CardCaptureStepEnum.assetBack && (
            <p className="text-gray-600 text-sm">
              Ensure the photo is taken from the back of the{' '}
              {getAssetSpecificContent(assetType as AssetTypesEnum).lowerTitle}{' '}
              with no obstructions.
            </p>
          )}
          {type === CardCaptureStepEnum.internalFront && (
            <p className="text-gray-600 text-sm">
              Capture a clear and complete photo of both the driver&apos;s and
              passenger&apos;s seats.
            </p>
          )}
          {type === CardCaptureStepEnum.internalBack && (
            <p className="text-gray-600 text-sm">
              Capture a clear and complete photo of the entire back seating
              area.
            </p>
          )}
          {type === CardCaptureStepEnum.internalBoot && (
            <p className="text-gray-600 text-sm">
              Capture a clear and complete photo of the boot area, showing its
              condition and space.
            </p>
          )}
          {type === CardCaptureStepEnum.internalLivingArea && (
            <p className="text-gray-600 text-sm">
              Capture the main seating, dining, or general interior space.
            </p>
          )}
          {type === CardCaptureStepEnum.internalKitchen && (
            <p className="text-gray-600 text-sm">
              Capture the kitchen area, whether it&apos;s internal or external.
            </p>
          )}
          {type === CardCaptureStepEnum.internalSleepingArea && (
            <p className="text-gray-600 text-sm">
              Capture the primary sleeping space (e.g., main bed, fixed bed, or
              primary sleeping arrangement).
            </p>
          )}
          {type === CardCaptureStepEnum.marineFront && (
            <p className="text-gray-600 text-sm">
              Ensure the photo is taken directly in front of the watercraft with
              no obstructions.
            </p>
          )}
          {type === CardCaptureStepEnum.marineBack && (
            <p className="text-gray-600 text-sm">
              Ensure the photo is taken from the back of the watercraft with no
              obstructions.
            </p>
          )}
          {type === CardCaptureStepEnum.marineLeft && (
            <p className="text-gray-600 text-sm">
              Ensure the photo is taken from the port side of the watercraft with
              no obstructions.
            </p>
          )}
          {type === CardCaptureStepEnum.marineRight && (
            <p className="text-gray-600 text-sm">
              Ensure the photo is taken from the starboard side of the watercraft
              with no obstructions.
            </p>
          )}
        </div>
        {!isDesktop && (
          <div className="flex flex-col gap-3 mb-20 mt-10">
            <h2 className="font-semibold">Tips</h2>
            <ul className="flex flex-col gap-3">
              <li className="inline-flex gap-2 text-grey-700 text-sm">
                <LightIcon color={primaryColor} />
                {type === CardCaptureStepEnum.internalFront ||
                type === CardCaptureStepEnum.internalBack ||
                type === CardCaptureStepEnum.internalBoot ||
                type === CardCaptureStepEnum.internalLivingArea ||
                type === CardCaptureStepEnum.internalKitchen ||
                type === CardCaptureStepEnum.internalSleepingArea
                  ? 'Ensure the area is well-lit'
                  : 'Find an area with good lighting'}
              </li>
              <li className="inline-flex gap-2 text-grey-700 text-sm">
                <EyeIcon color={primaryColor} />
                {type === CardCaptureStepEnum.internalFront ||
                type === CardCaptureStepEnum.internalBack
                  ? 'Keep the seats fully visible'
                  : type === CardCaptureStepEnum.internalLivingArea ||
                      type === CardCaptureStepEnum.internalKitchen ||
                      type === CardCaptureStepEnum.internalSleepingArea
                    ? 'Keep the area fully visible'
                    : type === CardCaptureStepEnum.internalBoot
                      ? 'Keep the entire boot visible'
                      : type === CardCaptureStepEnum.assetFront ||
                          type === CardCaptureStepEnum.assetLeft ||
                          type === CardCaptureStepEnum.assetRight ||
                          type === CardCaptureStepEnum.assetBack
                        ? 'Make sure the ' +
                          getAssetSpecificContent(assetType as AssetTypesEnum)
                            .lowerTitle +
                          ' is in full view'
                        : type === CardCaptureStepEnum.marineFront ||
                            type === CardCaptureStepEnum.marineBack ||
                            type === CardCaptureStepEnum.marineLeft ||
                            type === CardCaptureStepEnum.marineRight
                          ? 'Make sure the watercraft is in full view'
                          : 'Make sure all details are visible'}
              </li>
              <li className="inline-flex gap-2 text-grey-700 text-sm">
                <MobileIcon color={primaryColor} />
                {type === CardCaptureStepEnum.internalFront ||
                type === CardCaptureStepEnum.internalBack ||
                type === CardCaptureStepEnum.internalBoot ||
                type === CardCaptureStepEnum.internalLivingArea ||
                type === CardCaptureStepEnum.internalKitchen ||
                type === CardCaptureStepEnum.internalSleepingArea
                  ? 'Hold your device steady to avoid blur'
                  : 'Hold your device steady'}
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="fixed lg:relative lg:w-full lg:justify-end bottom-0 right-0 w-full px-4 py-6 bg-grey-50 flex flex-col gap-4 tablet-portrait:w-[361px] tablet-portrait:justify-center tablet-portrait:right-auto tablet-portrait:px-0">
        {!isDesktop && (
          <Button
            data-testid={captureButtonTestId('continue')}
            onClick={handleTakePictureForStep1}
            className={clsx(
              'font-semibold w-auto normal-case rounded text-base shadow-none py-[10px] px-[18px]',
              primaryColor && `bg-[${primaryColor}]`
            )}
            style={{ backgroundColor: primaryColor }}>
            Continue
          </Button>
        )}
        {type === DocumentCaptureStepEnum.bank && (
          <Button
            data-testid={captureButtonTestId('upload')}
            variant="text"
            className="text-grey-600 text-base normal-case rounded font-semibold py-[10px] px-[18px]"
            onClick={handleUpload}>
            Upload from your device or computer
          </Button>
        )}
      </div>
      {/* <LocationPrompt onLocationGranted={() => {}} onUpload={() => {}} /> */}

      <FileTypeErrorModal
        open={showFileTypeError}
        onClose={() => setShowFileTypeError(false)}
        primaryColor={primaryColor}
        message={fileErrorMessage}
      />
    </div>
  );
};


export default VehicleComponent;
